import type { TrialOfferContent } from '@/core/types';

import { TrialOfferV1 } from '@/containers/blocks/promotions';

export default function generate({
  content,
  className,
}: {
  content: TrialOfferContent;
  className?: string;
}) {
  return (
    <TrialOfferV1
      title={content.title}
      subtitle={content.subtitle}
      items={content.items}
      buttons={content.buttons}
      image={content.image}
      className={className}
    />
  );
}
